"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.httpContextIntegration = void 0;

var _core = require("@sentry/core");

var _helpers = require("../helpers.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */
const httpContextIntegration = exports.httpContextIntegration = (0, _core.defineIntegration)(() => {
  return {
    name: 'HttpContext',

    preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!_helpers.WINDOW.navigator && !_helpers.WINDOW.location && !_helpers.WINDOW.document) {
        return;
      } // grab as much info as exists and add it to the event


      const url = event.request && event.request.url || _helpers.WINDOW.location && _helpers.WINDOW.location.href;

      const _ref = _helpers.WINDOW.document || {},
            referrer = _ref.referrer;

      const _ref2 = _helpers.WINDOW.navigator || {},
            userAgent = _ref2.userAgent;

      const headers = _objectSpread(_objectSpread(_objectSpread({}, event.request && event.request.headers), referrer && {
        Referer: referrer
      }), userAgent && {
        'User-Agent': userAgent
      });

      const request = _objectSpread(_objectSpread(_objectSpread({}, event.request), url && {
        url
      }), {}, {
        headers
      });

      event.request = request;
    }

  };
});